import { render, staticRenderFns } from "./associatePlayers.vue?vue&type=template&id=45df2280&scoped=true"
import script from "./associatePlayers.vue?vue&type=script&lang=js"
export * from "./associatePlayers.vue?vue&type=script&lang=js"
import style0 from "./associatePlayers.vue?vue&type=style&index=0&id=45df2280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df2280",
  null
  
)

export default component.exports